import React, { useMemo, Fragment } from 'react';
import breadcrumb from "./props";
import style from "./style.module.scss";
import classNames from '../../../utils/classNames';
import config from './config.json';

import Toolbar from '../../private/Toolbar';
import ToolbarProps from '../../private/Toolbar/props';

import link from '../../private/Link/props';
import './styles.scss';

function LuxuryBreadcrumb(props: breadcrumb) {
  const linkDeviceClass = props.device ? ` breadcrumbs-luxury__link_${props.device}` : '';
  
  return (
    <div className="breadcrumbs-luxury">
      {  props.items.map((item, index) => (
        <Fragment key={index}>
          <a className={`breadcrumbs-luxury__link${linkDeviceClass}`} href={item.url}>{item.text}</a>
          { props.items.length !== (index + 1) && <span className="breadcrumbs-luxury__chevron" /> }
        </Fragment>
      ))}
    </div>
  );
}

function StandardBreadcrumb(props: breadcrumb) {
  const toolbarProps = useToolbarProps(props);
  
  return (
    <div className={classNames('breadcrumb', style)}>
     <Toolbar {...toolbarProps} />
    </div>
  );
}

function Breadcrumb(props: breadcrumb) {
  if (props.luxury) {
    return <LuxuryBreadcrumb {...props} />;
  }
  
  return <StandardBreadcrumb {...props} />;
}


const useToolbarProps = (props: breadcrumb): ToolbarProps => {
  return useMemo(() => {
    return {
      schema: config.Toolbar.schema,
      items: props.items.map(item => {
        return {
          ...item,
          Link: {
            text: item.text,
            url: item.url,
            property: config.Toolbar.items.Link.property,
            typeOf: config.Toolbar.items.Link.typeOf,
            classNames: config.Toolbar.items.Link.classNames
          } as link
        }
      }),
      classNames: config.Toolbar.classNames
    };
  }, [props]);
}

export default React.memo(Breadcrumb);